import React, { useState, useEffect, useCallback } from "react";
import InputFactory from "../../../components/InputFactory";

function DialogCreate({ create, objects, handleSubmit, handleClose }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    reason: "",
  });

  const formatLastName = (name) => {
    if (!name || typeof name !== "string") return "";

    return name
      .split(" ")
      .filter((part) => part.trim().length > 0)
      .map((part) => part[0]?.toUpperCase() + ".")
      .join(" ");
  };

  const handleChange = useCallback((value, field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: field === "lastName" ? formatLastName(value) : value,
    }));
    console.log(formData);
  }, []);

  const _handleSubmit = useCallback(() => {
    const updatedFormData = {
      ...formData,
      ...objects,
    };
    console.log(updatedFormData);
    handleSubmit(updatedFormData);
  }, [formData, handleSubmit]);

  return (
    <div className="p-4 rounded" style={{ maxWidth: "450px", margin: "auto" }}>
      <div
        className="d-flex align-items-center mb-3"
        style={{ color: "#d18237" }}
      >
        <div
          className="bg-light p-3 rounded-circle d-flex justify-content-center align-items-center"
          style={{ width: "50px", height: "50px" }}
        >
          <i className="bi bi-plus-circle fs-4"></i>
        </div>
        <h5 className="fw-bold ms-2">Add to Queue</h5>
      </div>

      <form onSubmit={_handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">First Name</label>
          <InputFactory
            type="String"
            field="firstName"
            required
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter first name"
            defaultValue={
              formData.qualificationStandard || objects?.qualificationStandard
            }
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Last Name</label>
          <InputFactory
            type="String"
            field="lastName"
            required
            onChange={(value, field) => handleChange(value, field)}
            placeholder="Enter last name"
          />
        </div>

        {objects?.name && objects?.name === "Others" ? (
          <div className="mb-3">
            <label className="form-label fw-bold">Reason</label>

            <textarea
              className="w-100 rounded-1 p-2"
              placeholder="Enter remarks here..."
              required
              style={{
                fontSize: "0.9rem",
                maxHeight: "170px",
                minHeight: "100px",
              }}
              onChange={(e) => handleChange(e.target.value, "reason")}
              onInput={(e) => {
                e.target.style.height = "auto";
                e.target.style.height = `${Math.min(
                  e.target.scrollHeight,
                  150
                )}px`;
              }}
            ></textarea>

            {/* <InputFactory
              type="String"
              field="reason"
              required
              onChange={(value, field) => handleChange(value, field)}
              placeholder="Enter last name"
            /> */}
          </div>
        ) : (
          ""
        )}

        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="btn text-white me-2 px-4"
            style={{ backgroundColor: "#d18237" }}
            // onClick={() => _handleSubmit()}
          >
            Confirm
          </button>
          <button
            className="btn px-4"
            onClick={() => handleClose()}
            style={{ backgroundColor: "#d0d0d0" }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default DialogCreate;
